import { createContext } from 'react'

export type FeatureFlagValue = Record<string, boolean>

const FeatureFlagsContext = createContext<FeatureFlagValue | null>(null)
FeatureFlagsContext.displayName = 'FeatureFlags'

export default FeatureFlagsContext
